import { ChangeDetectionStrategy, Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationService } from '@core';
import { WhatsNewService, WhatsNewVersionView } from '@update';
import { SzBrandBlockComponent, SzIconComponent, SzIconName } from '@ui';

const FALLBACK_ICON: SzIconName = 'star';

@Component({
  selector: 'app-whats-new-page',
  templateUrl: './whats-new.page.html',
  styleUrls: ['./whats-new.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, SzBrandBlockComponent, SzIconComponent]
})
export class WhatsNewPage implements OnInit {
  readonly versions: WritableSignal<ReadonlyArray<WhatsNewVersionView>> = signal<ReadonlyArray<WhatsNewVersionView>>(
    []
  );
  readonly loading: WritableSignal<boolean> = signal<boolean>(true);
  readonly expanded: WritableSignal<string | null> = signal<string | null>(null);

  private readonly navigation: NavigationService = inject(NavigationService);
  private readonly whatsNew: WhatsNewService = inject(WhatsNewService);

  async ngOnInit(): Promise<void> {
    const list: WhatsNewVersionView[] = await this.whatsNew.loadHistory();
    this.versions.set(list);
    if (list.length > 0) {
      this.expanded.set(list[0].version); // najnowsza wersja rozwinięta domyślnie
    }
    this.loading.set(false);
  }

  toggle(version: string): void {
    this.expanded.update((cur: string | null): string | null => (cur === version ? null : version));
  }

  isExpanded(version: string): boolean {
    return this.expanded() === version;
  }

  iconFor(raw: string): SzIconName {
    return (raw || FALLBACK_ICON) as SzIconName;
  }

  goBack(): void {
    this.navigation.back();
  }
}
